// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MehTwoToneSvg from "@ant-design/icons-svg/es/asn/MehTwoTone";
import AntdIcon from '../components/AntdIcon';

var MehTwoTone = function MehTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MehTwoToneSvg
  }));
};

MehTwoTone.displayName = 'MehTwoTone';
export default React.forwardRef(MehTwoTone);